module.exports = __webpack_public_path__ + "static/media/ic_CompanyProfile.71d9d091.svg";